var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalling(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.29,
    height: 17.944,
    viewBox: "0 0 18.29 17.944",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 1",
    d: "M0 0a7 7 0 0 1 6.181 6.174",
    transform: "translate(11.446 .663)",
    style: {
      fill: "none",
      stroke: "#151aae",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 3",
    d: "M0 0a3.886 3.886 0 0 1 3.073 3.073",
    transform: "translate(11.446 3.774)",
    style: {
      fill: "none",
      stroke: "#151aae",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Stroke 5",
    d: "M7.93 8.756c3.5 3.5 4.3-.549 6.527 1.679 2.15 2.149 3.386 2.58.662 5.3-.341.274-2.509 3.573-10.127-4.043S.669 1.907.943 1.566c2.73-2.731 3.154-1.488 5.3.661 2.233 2.23-1.816 3.027 1.687 6.529z",
    transform: "translate(.6 .663)",
    style: {
      fill: "none",
      stroke: "#151aae",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.2px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalling);
export default __webpack_public_path__ + "static/media/Calling.d091c8a97a46bbd91cb88e8b2a6578ca.svg";
export { ForwardRef as ReactComponent };